// components/Sidebar.tsx
import React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupIcon from "@mui/icons-material/Group";
import SchoolIcon from "@mui/icons-material/School";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { ListItemButton, ListItemIcon } from "@mui/material";
import { Link, Router } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import ClassIcon from "@mui/icons-material/Class";
import PeopleIcon from "@mui/icons-material/People";

type SidebarProps = {
  open: boolean;
  toggleSidebar: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ open, toggleSidebar }) => (
  <Drawer anchor="left" open={open} onClose={toggleSidebar}>
    <List>
      <ListItemButton component={Link} to="/admin/">
        <ListItemIcon>
          <SupervisedUserCircleIcon />
        </ListItemIcon>
        <ListItemText primary="Admin" />
      </ListItemButton>
      <List component="div" disablePadding>
        <ListItemButton component={Link} to="/admin/schools" sx={{ pl: 4 }}>
          <ListItemIcon>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText primary="Schools" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/teachers" sx={{ pl: 4 }}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="Teachers" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/classrooms" sx={{ pl: 4 }}>
          <ListItemIcon>
            <ClassIcon />
          </ListItemIcon>
          <ListItemText primary="Classrooms" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/students" sx={{ pl: 4 }}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Students" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/programs" sx={{ pl: 4 }}>
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText primary="Programs" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/admin/placement-test"
          sx={{ pl: 4 }}
        >
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Placement Test" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/our-team" sx={{ pl: 4 }}>
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary="Our Team" />
        </ListItemButton>
      </List>
    </List>
  </Drawer>
);

export default Sidebar;
/*
help me design the data structure 
student will be assigned to one of the  3 programs, 'yellow' 'green' 'access'
yello will have 20 weeks of contents, green 20 week, access 12 weeks
each weekly content is locked until the certain days(next point below) after program start date,
weekly content duration can be every four days , weekly or 8 days, but durations can’t be shorter than 8 weeks
each weekly conent will have 7 modules Reading, Listening, Speaking, Writing, Grammar, Review, Vocabulary
each module will have four to five types of questions
quection can be multiple choice, fill in the blank, listen and answer question, summary of article, matching words, speaking


how do I structure the db



*/
